import * as React from "react";
import * as ReactDOM from "react-dom";
import { Route, Link } from "react-router-dom";
import { save as saveCourse, unsave as unsaveCourse } from "../../api/save";
import SearchBoxDebounced from "../../components/SearchBoxDebounced";
import algoliasearch from 'algoliasearch' ;
import qs = require("qs");
//const Fuse = require("fuse.js");
import Truncate from "react-truncate";

import {
	InstantSearch,
	Hits,
	Highlight,
	//Snippet,
	RefinementList,
	NumericMenu,
	Stats,
	Pagination,
	Configure,
	HierarchicalMenu,
	ClearRefinements,
	Menu,
	ToggleRefinement,
	connectCurrentRefinements,
	connectRefinementList,
	connectNumericMenu,
	connectHierarchicalMenu,
	connectStateResults,
	connectMenu,
	connectToggleRefinement,
	connectSearchBox,
	connectHits,
	connectSnippet,
	connectHighlight,
	connectHitInsights
} from "react-instantsearch-dom";
import { AlgoliaSearchOptions } from "algoliasearch";
import { isNull } from "node:util";

const Snippet = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: '_snippetResult',
    attribute,
    hit,
  });

  return (
    <div className="f6 black-80 lh-copy">
      {parsedHit.map(
		(part, index) =>
          part.isHighlighted ? (
            <span className="fw6" key={index} dangerouslySetInnerHTML={{
				__html: part.value
			}} />
          ) : (
            <span key={index} dangerouslySetInnerHTML={{
				__html: part.value
			}} />
          )
      )}
    </div>
  );
};

const CustomSnippet = connectHighlight(Snippet);

const rawStore = {
	savedCourses: new Set<number>([...(window["__SEARCH_CONFIGURATION__"].savedCourseIds || [])]),
	adsCampaigns: new Set<string>([...(window["__SEARCH_CONFIGURATION__"].adsCampaigns || [])]),
	forceUpdate: () => console.warn("forceUpdate has not been registered")
};

const store = React.createContext(rawStore);

interface ResultProps {
	isSaved?: boolean;

	insights: (eventID: string, { eventName: string }) => void,

	hit: {
		objectID;
		name: string;
		url;
		broadFieldName;
		duration;
		durationTextOverride;
		providerName;
		providerLogo;
		providerUrl;
		providerType;
		priceDomesticFormatted;
		priceInternationalFormatted;
		level;
		medianEarningsFormatted;
		completionRateFormatted;
		postStudyEmployment;
		postStudyStudying;
		isShortCourse?: boolean;
		isMicroCredential?: boolean;

		_highlightResult: {
			name: {
				value: string;
			}
			majors?: {
				matchLevel: "none" | "full" | "partial",
				value: string;
			}[];
		}

		_snippetResult: {
			description: {
				value: string;
			}
		}
	}
}

interface ResultState {
	saved?: boolean;
}

class ResultRaw extends React.Component<ResultProps, ResultState> {
	render() {
		const hit = this.props.hit;
		let isExternalLink = false;

		let courseClickEvent = () => {
			this.props.insights("clickedObjectIDsAfterSearch", { eventName: "Course Clicked" });
		};

		let providerClickEvent = () => {
			this.props.insights("clickedObjectIDsAfterSearch", { eventName: "Provider Clicked" });
		}

		if ((hit as any).isPromoted) {
			isExternalLink = !hit.url.includes("studyspy.ac.nz");

			courseClickEvent = () => {
				navigator.sendBeacon((hit as any).clickTrackingLink);
			};

			providerClickEvent = () => {
				navigator.sendBeacon((hit as any).clickTrackingLink);
			};
		}

		return (
			<store.Consumer>
				{state =>
					<div
						className="flex flex-column h-100"
						style={{ justifyContent: "space-between" }}
					>
						<div className="flex flex-column" style={{ flex: "1" }}>
							<div className="dt w-100">
								<div className="dtc w-190 v-top">
									<h2 className="ma0 fw5 mt2">
										<a
											className="db mh3 link brand-font underline-hover item-title"
											href={hit.url}
											style={{ fontSize: 19, lineHeight: 1.3 }}
											onClick={courseClickEvent}
											target={isExternalLink ? "_blank" : undefined}
										>
											<Truncate lines={3}>
												{hit.name}
											</Truncate>
										</a>
									</h2>

									{(hit as any).isPromoted &&
										<div
											title={(hit as any).score}
											className="default f7 ttu tc dib lh-solid br2 mt2 black-50 bg-black-05 ph2 pv1 ml3"
										>
											Promoted
										</div>
									}
								</div>
								<div className="dtc pr3">
									{state.savedCourses.has(Number(hit.objectID)) ? (
										<div
											style={{ backgroundColor: "#fafafa", borderColor: "#f0f3f5" }}
											className="pointer ba bg-white dim black-40 brand-font br2 f6 tc pa2 fw6 f6 ttu link v-mid"
											onClick={async () => {
												try {
													await unsaveCourse(hit.objectID);
													rawStore.savedCourses.delete(Number(hit.objectID));
													rawStore.forceUpdate();
												}
												catch (e) {
													console.error(e);
												}
											}}
										>
											<svg fill="#E6686E" height="24" viewBox="0 0 24 24" width="24" className="db v-mid" xmlns="http://www.w3.org/2000/svg">
												<path d="M0 0h24v24H0z" fill="none"/>
												<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
											</svg>
										</div>
									) : (
										<div
											style={{ backgroundColor: "#fafafa", borderColor: "#f0f3f5" }}
											className="pointer ba bg-white dim black-40 brand-font br2 f6 tc pa2 fw6 f6 ttu link db v-mid"
											onClick={async () => {
												try {
													var response = await saveCourse(hit.objectID);

													if (response.status == 302 || response.status >= 401) {
														window.location.href = "/account/register?returnUrl=/save/course/" + hit.objectID;
														return;
													}

													rawStore.savedCourses.add(Number(hit.objectID));
													rawStore.forceUpdate();
												}
												catch (e) {
													console.error(e);
												}
											}}
										>
											<svg fill="currentcolor" height="24" viewBox="0 0 24 24" width="24" className="dib v-mid">
												<path d="M0 0h24v24H0z" fill="none"></path>
												<path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path>
											</svg>
										</div>
									)}
								</div>
							</div>

							<div className="dt w-100" style={{ height: "72px" }}>
								<div className="dtc v-mid pa2 pl3" style={{ width: "48px" }}>
									<a className="br2 bg-white pa1 ba b--black-05 db" href={hit.providerUrl} onClick={providerClickEvent}>
										<div className="center tc flex items-center justify-center" style={{ width: "42px", height: "42px" }}>
											<img src={hit.providerLogo} alt="" style={{ maxHeight: "42px", maxWidth: "42px" }} />
										</div>
									</a>
								</div>
								<div className="dtc pa3 pl2">
									<a href={hit.providerUrl} onClick={providerClickEvent}>
										<h3 className="mt1 dib f6 fw5 black-80 lh-title mb0">
											{hit.providerName}
										</h3>
									</a>
									<div className="mt1" style={{ color: "#777", fontSize: "12px" }}>
										{hit.providerType}
									</div>
								</div>
							</div>

							{!!(
								hit.duration ||
								hit.durationTextOverride ||
								hit.level
							) &&
								<table
									className="collapse w-100 f6 lh-title mt3 pt3"
									style={{ tableLayout: "fixed", captionSide: "bottom" }}
								>
									<caption className="clip">{hit.name}</caption>
									<tbody>
										{!!(hit.durationTextOverride || hit.duration) &&
											<tr className="bt b--black-05">
												<th className="ph3 pv1 ttu f7 black-60" scope="row">Duration</th>
												<td className="pr3 pv1">{hit.durationTextOverride || hit.duration}</td>
											</tr>
										}
										{!!hit.level &&
											<tr className="bt b--black-05">
												<th className="ph3 pv1 ttu f7 black-60" scope="row">NZQF Level</th>
												<td className="pr3 pv1">{hit.level}</td>
											</tr>
										}
									</tbody>
								</table>
							}

							<div className="bt b--black-05" />

							<div className="ma3 pv2">
								<CustomSnippet attribute="description" hit={hit} />
							</div>

							{!!((hit as any).isPromoted) &&
								<a
									href={(hit as any).url}
									style={{ marginTop: "auto" }}
									className="db link white bg-brand-blue mh3 mb3 ph3 pv2 br2 tc dim"
									onClick={courseClickEvent}
									target={isExternalLink ? "_blank" : undefined}
								>
									Learn more
								</a>
							}

							{/* Tracking pixel */}
							{!!(hit as any).viewTrackingPixel &&
								<img src={(hit as any).viewTrackingPixel} width="1" height="1" alt="" />
							}
						</div>
					</div>
				}
			</store.Consumer>
		);
	}
}

const Result = connectHitInsights((window as any).aa)(ResultRaw);

interface FilterProps {
	label: string;
	refine?(x?);
	isRefined: boolean;
	currentRefinement?: string[] | string;
	canRefine?: boolean;
	items?: {
		count: number;
		isRefined: boolean;
		label: string;
		value: any; // probably an array
	}[];
	clear(x?);
}

interface FilterState {
	isOpen: boolean;
}

class Filter extends React.Component<FilterProps, FilterState> {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};
	}

	open = () => {
		this.setState({ isOpen: true });
		document.body.classList.add("modal-open");

	}

	close = () => {
		this.setState({ isOpen: false });
		document.body.classList.remove("modal-open");
	}

	render() {
		const canRefine = this.props.canRefine;

		return (
			<div className="dib mr2 mt2">
				<div
					className={`${canRefine ? "pointer" : "black-50" } dt w-100 brand-font ba b--black-10 f6 ${this.props.isRefined ? "bg-brand-blue white" : "bg-white black-80"}`}
					onClick={canRefine ? this.open : () => {}}
					style={{ borderRadius: "4px" }}
				>
					<div className={`ma2 dtc v-mid ${canRefine ? "dim" : ""} ${this.props.isRefined ? "ph2" : "pa2"}`}>
						{this.props.label}
					</div>

					{this.props.isRefined &&
						<button
							className="b--white-10 dtc bg-transparent dim v-mid pa2 br2 white-90 pointer"
							style={{ width: "32px", height: "100%", borderStyle: "none none none solid", borderWidth: "1px" }}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								this.props.clear();
								// blur target, select X or view results?
							}}
						>
							<svg
								focusable="false"
								aria-label="Close"
								viewBox="0 0 32 32"
								width="14"
								height="14"
								fill="none"
								stroke="currentcolor"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								style={{
									marginTop: "1px",
									marginBottom: "-2px"
								}}
							>
								<path d="M2 30 L30 2 M30 30 L2 2" />
							</svg>
						</button>
					}
				</div>
				{ReactDOM.createPortal(
					<div className="modal" style={{ display: this.state.isOpen ? "block" : "none" }}>
						<div
							className="modal__internals"
							aria-hidden="true"
							role="dialog"
							tabIndex={-1}
						>
							<div className="modal__body">
								<div className="modal__header">
									<div className="modal__close">
										<button
											className="modal__close__button"
											onClick={this.close}
										>
											<svg
												focusable="false"
												aria-label="Close"
												viewBox="0 0 32 32"
												width="15"
												height="15"
												fill="none"
												stroke="currentcolor"
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth="2"
											>
												<path d="M2 30 L30 2 M30 30 L2 2" />
											</svg>
										</button>
									</div>
									{this.props.isRefined &&
										<div className="modal__clear">
											<div className="modal__clear__internal">
												<button
													type="button"
													className="modal__clear__internal__button brand-blue"
													onClick={() => this.props.clear()}
												>
													<span>Clear</span>
												</button>
											</div>
										</div>
									}
								</div>

								<div className="modal__scroll">
									{this.props.children}
								</div>
							</div>

							<div className="modal__footer">
								<button
									type="button"
									className="modal__footer__button"
									onClick={this.close}
								>
									<span>View results</span>
								</button>
							</div>
						</div>
					</div>,
					document.getElementById("modal-container")
				)}
			</div>
		);
	}
}

/* PROVIDER FILTER */
let ProviderFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Providers";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Providers (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				limit={999}
				attribute={props.attribute}
			/>
		</Filter>
	);
};

ProviderFilter = connectRefinementList(ProviderFilter);
/* PROVIDER FILTER */

/* REGION FILTER */
let RegionFilter = (props: { attribute: string, currentRefinement?: any, refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "object" && props.currentRefinement.length > 0
	let label = "Regions";

	if (isRefined) {
		if (props.currentRefinement.length == 1) {
			const labelLength = 17;

			label = props.currentRefinement[0].substring(0, labelLength);

			if (props.currentRefinement[0].length > labelLength) {
				label += "...";
			}
		}
		else {
			label = "Regions (" + props.currentRefinement.length + ")";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={(typeof props.currentRefinement == "object" && props.currentRefinement.length > 0)}
			clear={() => props.refine({})}
		>
			<RefinementList
				searchable
				limit={999}
				attribute={props.attribute}
			/>
		</Filter>
	);
};

RegionFilter = connectRefinementList(RegionFilter);
/* REGION FILTER */

/* DURATION FILTER */
const durationItems = [
	{ label: "All" },
	{  end: 119, label: 'Less than 1 year' },
	{ start: 120, end: 240, label: '1 year' },
	{ start: 240, end: 360, label: '2 years' },
	{ start: 360, label: '3+ years' }
];

let DurationFilter = (props: { attribute: string, currentRefinement?: string, items: any[], refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "string" && props.currentRefinement.length > 0
	let label = "Duration";

	if (isRefined) {
		const realValue = props.items.find(x => x.value == props.currentRefinement!);
		label = realValue.label;
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={isRefined}
			clear={() => props.refine("")}
		>
			<NumericMenu
				attribute={props.attribute}
				items={durationItems}
			/>
		</Filter>
	);
};

DurationFilter = connectNumericMenu(DurationFilter);
/* DURATION FILTER */

/* LEVEL FILTER */
const levelItems = [
	{ label: 'All' },
	{ end: 7, label: 'Undergraduate' },
	{ start: 8, label: 'Postgraduate' },
	{ start: 1, end: 1, label: 'Level 1 - Certificate' },
	{ start: 2, end: 2, label: 'Level 2 - Certificate' },
	{ start: 3, end: 3, label: 'Level 3 - Certificate' },
	{ start: 4, end: 4, label: 'Level 4 - Certificate' },
	{ start: 5, end: 5, label: 'Level 5 - Certificate, Diploma' },
	{ start: 6, end: 6, label: 'Level 6 - Certificate, Diploma' },
	{ start: 7, end: 7, label: 'Level 7 - Diploma, Bachelor, Graduate Certificate, Graduate Diploma' },
	{ start: 8, end: 8, label: 'Level 8 - Bachelor Honours, Postgraduate Certificate, Postgraduate Diploma' },
	{ start: 9, end: 9, label: 'Level 9 - Master\'s Degree' },
	{ start: 10, end: 10, label: 'Level 10 - Doctoral Degree' },
];

let LevelFilter = (props: { attribute: string, currentRefinement?: string, items: any[], refine?: any }) => {
	const isRefined = typeof props.currentRefinement == "string" && props.currentRefinement.length > 0
	let label = "Level";

	if (isRefined) {
		const labelLength = 17;
		const realValue = props.items.find(x => x.value == props.currentRefinement!);
		label = realValue.label.substring(0, labelLength);

		if (realValue.label.length > labelLength) {
			label += "...";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={isRefined}
			clear={() => props.refine("")}
		>
			<NumericMenu
				attribute={props.attribute}
				items={levelItems}
			/>
		</Filter>
	);
};

LevelFilter = connectNumericMenu(LevelFilter);
/* LEVEL FILTER */

/* SUBJECT FILTER */
const subjectAttributes = [
	'hierarchicalCategories.lvl0',
	'hierarchicalCategories.lvl1',
	'hierarchicalCategories.lvl2'
];

let SubjectFilter = (props: { attributes: string[], currentRefinement?: any, limit?: number, items?: any[], refine?(x): any }) => {
	const isRefined = typeof props.currentRefinement == "string" && props.currentRefinement.length > 0;
	let label = "Subject";

	if (isRefined) {
		const labelLength = 17;
		label = props.currentRefinement!.substring(0, labelLength);

		if (props.currentRefinement!.length > labelLength) {
			label += "...";
		}
	}

	return (
		<Filter
			label={label}
			{...props}
			isRefined={isRefined}
			clear={() => props.refine!(props.currentRefinement!.value)}
		>
			<ul className="list ma0 pa0">
				{props.items!.map(x =>
					<li className="bt b--black-05" key={x.label}>
						<div
							className={`brand-font f5 ph3 pv3 pointer dim ${x.isRefined ? "brand-blue fw6" : ""}`}
							onClick={() => props.refine!(x.value)}
						>
							{x.label}
							<span className="fw5 black-50 pl2">{x.count}</span>
						</div>

						{x.isRefined &&
							<ul className="list ma0 pa0">
								{x.items.map(y =>
									<li className="brand-font bt b--black-05" key={y.label}>
										<div
											className={`brand-font f5 pr3 pl4 pv3 black-80 pointer dim ${y.isRefined ? "fw6" : ""}`}
											onClick={() => props.refine!(y.value)}
										>
											{y.label}

											{y.isRefined ? (
												<svg
													viewBox="0 0 32 32"
													width="16"
													height="16"
													fill="none"
													stroke="currentcolor"
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth="2"
													className="green ml2 dib"
												>
													<path d="M2 20 L12 28 30 4" />
												</svg>
											) : (
												<span className="fw5 black-50 pl2">{y.count}</span>
											)}
										</div>

										{y.isRefined && (
											<ul className="list ma0 pa0">
												{y.items.map(z =>
													<li
														className="brand-font bt b--black-05 pv2 black-70"
														key={z.label}>
														<div
															className={`brand-font f5 pr3 pl5 pv2 black-70 pointer dim ${z.isRefined ? "fw6" : ""}`}
															onClick={() => props.refine!(z.value)}
														>
															{z.label}

															{z.isRefined ? (
																<svg
																	viewBox="0 0 32 32"
																	width="16"
																	height="16"
																	fill="none"
																	stroke="currentcolor"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																	strokeWidth="2"
																	className="green ml2 dib"
																>
																	<path d="M2 20 L12 28 30 4" />
																</svg>
															) : <span className="fw5 black-50 pl2">{z.count}</span>}
														</div>
													</li>
												)}
											</ul>
										)}
									</li>
								)}
							</ul>
						}
					</li>
				)}
			</ul>
		</Filter>
	);
};

SubjectFilter = connectHierarchicalMenu(SubjectFilter);
/* SUBJECT FILTER */

/* MICRO CREDENTIAL FILTER *
let MicroCredentialFilter = (props: {
	attribute: string,
	currentRefinement?: string,
	count?: object,
	refine?: any
}) => {
	const isRefined = typeof props.currentRefinement == "string" && props.currentRefinement.length > 0
	let label = "Micro-credential";

	if (isRefined) {
		console.log(1);
	}

	return (
		<InlineFilter
			label={label}
			{...props}
			isRefined={isRefined}
			clear={() => props.refine("")}
		>
			<div>
				Bonk
			</div>
		</InlineFilter>
	);
};

MicroCredentialFilter = connectToggleRefinement(MicroCredentialFilter);
/ END MICRO CREDENTIAL FILTER */

interface FiltersProps {

}

interface FiltersState {

}

class Filters extends React.Component<FiltersProps, FiltersState> {
	render() {
		return (
			<div className="search__filter-bar cf">
				<div className="search__filter-bar__content mw9-l center">
					<LevelFilter attribute="level" items={levelItems} />
					<DurationFilter attribute="credits" items={durationItems} />
					<SubjectFilter attributes={subjectAttributes} limit={500} />
					<ProviderFilter attribute="providerName" />
					<RegionFilter attribute="regions" />
					{/*<MicroCredentialFilter attribute="IsMicroCredential" />*/}
				</div>
			</div>
		);
	}
}

const ConnectedFilters = connectCurrentRefinements(Filters);

const appId = window["__SEARCH_CONFIGURATION__"].appId;
const apiKey = window["__SEARCH_CONFIGURATION__"].apiKey;
const indexName = "courses";

/** AD CAMPAIGN PROMOTIONS **/
const promotions = window["__SEARCH_CONFIGURATION__"].promotions;
let adCampaignsPromotions;
let hitCountPromotion = 12; // 12 hits (default) if no promotion matches.
if (!!promotions) {
	promotions.sort((a, b) => b.priority - a.priority);
	adCampaignsPromotions = promotions.map(promotion => {
		return {
			keywords: promotion.keywords,
			negativeKeywords: promotion.negativeKeywords,
			promotionData: {
				id: promotion.id,
				objectID: promotion.id.toString(),
				providerId: promotion.providerId,
				providedBy: promotion.providerName,
				providerName: promotion.providerName,
				providerType: promotion.providerType,
				providerUrl: promotion.providerUrl,
				providerLogo: promotion.providerLogo,
				isPromoted: true,
				name: promotion.name,
				description: promotion.description,
				url: promotion.url,
				viewTrackingPixel: promotion.viewTrackingPixel,
				clickTrackingLink: promotion.clickTrackingLink,
				_snippetResult: {
					description: {
						value: promotion.description,
					},
				}
			}
		};
	});
}
/** END AD CAMPAIGN PROMOTIONS **/

const techfutureslabPromoDetails = {
	providerId: 824,
	providedBy: "Tech Futures Lab",
	providerName: "Tech Futures Lab",
	providerType: "Private Training Establishment (PTE)",//
	providerUrl: "https://studyspy.ac.nz/providers/824/tech-futures-lab",
	providerLogo: "https://ucarecdn.com/77301770-fbe3-42d6-819a-b7101e1d851c/-/preview/288x288/-/format/webp/",
	isPromoted: true,
};

const techfutureslabDisruptivePromoHits = [
	{
		// https://studyspy.ac.nz/courses/16460/disruptive-technologies-micro-credential
		...techfutureslabPromoDetails,
		id: 16460,
		objectID: "16460",
		level: 2,
		name: "Disruptive Technologies Micro-credential",
		description: "Learn from industry experts about real-world industry disruptions and develop your understanding of how current and emerging technologies could be used as strategic tools in your practice.",
		url: "https://techfutureslab.com/disruptive-technologies/?utm_source=StudySpy&utm_medium=Searchad&utm_campaign=DT&utm_id=www.techfutureslab.com",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1829902;BID=520715692;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1829902&setID=344408&channelID=0&CID=673906&banID=520715692&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=eac0c1c8f10dad124214904591d78cb24693d6b0&location=",
		_snippetResult: {
			description: {
				value: "Learn from industry experts about real-world industry disruptions and develop your understanding of how current and emerging technologies could be used as strategic tools in your practice.",
			},
		}
	},


];


const techfutureslabPostGradPromoHits = [
	{
		// https://studyspy.ac.nz/courses/16459/postgraduate-certificate-in-connected-environments
		...techfutureslabPromoDetails,
		id: 16459,
		objectID: "16459",
		level: 8,
		name: "Postgraduate Certificate in Connected Environments",
		description: "Learn how connected technologies like IoT, machine learning and artificial intelligence can draw insight from environments to enhance knowledge so you can design better outcomes, for people, place and planet.",
		url: "https://techfutureslab.com/connected-environments/?utm_source=StudySpy&utm_medium=Searchad&utm_campaign=CE&utm_id=www.techfutureslab.com",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1829902;BID=520724721;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1829902&setID=344408&channelID=0&CID=673906&banID=520724721&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=e91349586d4c99fd6d3d48c92fa319efb7f5912b&location=",
		_snippetResult: {
			description: {
				value: "Learn how connected technologies like IoT, machine learning and artificial intelligence can draw insight from environments to enhance knowledge so you can design better outcomes, for people, place and planet.",
			},
		}
	},


];

const techfutureslabMTFPromoHits = [
	{
		// https://studyspy.ac.nz/courses/16457/master-of-technological-futures
		...techfutureslabPromoDetails,
		id: 16457,
		objectID: "16457",
		level: 9,
		name: "Master of Technological Futures",
		description: "Learn to innovate and redesign for a better world using emerging disruptive technologies and contemporary business practices. An industry-led future forward programme that focuses on real-world problem solving, specific to your purpose, your context and your aspirations. Carve out a new direction, evolve your career or prepare yourself to start your own initiative.",
		url: "https://techfutureslab.com/master-of-technological-futures/?utm_source=StudySpy&utm_medium=Searchad&utm_campaign=MTF&utm_id=www.techfutureslab.com",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1829902;BID=520739979;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1829902&setID=344408&channelID=0&CID=673906&banID=520739979&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=c31c432dd8e38b7c6b008437c742c0f537607e6a&location=",
		_snippetResult: {
			description: {
				value: "Learn to innovate and redesign for a better world using emerging disruptive technologies and contemporary business practices. An industry-led future forward programme that focuses on real-world problem solving, specific to your purpose, your context and your aspirations. Carve out a new direction, evolve your career or prepare yourself to start your own initiative.",
			},
		}
	},


];


const ignitePromoDetails = {
	providerId: 192,
	providedBy: "Ignite Colleges",
	providerName: "Ignite Colleges",
	providerType: "Private Training Establishment (PTE)",
	providerUrl: "https://studyspy.ac.nz/providers/192/ignite-colleges",
	providerLogo: "https://ucarecdn.com/d6558647-a106-494c-a1eb-4547e85d5bae/-/preview/288x288/-/format/webp/",
	isPromoted: true,
};


const igniteHealthPromoHits = [
	{
		// https://studyspy.ac.nz/courses/72/nz-certificate-in-health-and-wellbeing-level-2-online
		...ignitePromoDetails,
		id: 72,
		objectID: "72",
		level: 2,
		name: "NZ Certificate in Health and Wellbeing Level 2",
		description: "2022 is your chance to ENROL now for FREE healthcare courses at levels 2, 3, 4 and 5 and gain a pay rise through pay equity. There is huge employer demand for dedicated and qualified healthcare workers - and thanks to the country’s growing, aging population it’s a sector that’s on the rise. Employment opportunities are vast, and offer the chance to make a real difference. Working as a health professional will set you on the path of a truly rewarding career!",
		url: "https://studyspy.ac.nz/courses/72/nz-certificate-in-health-and-wellbeing-level-2-online",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604650;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604650&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=df84e100f67d4f51594f40e20d27659395196c49&location=",
		_snippetResult: {
			description: {
				value: "2022 is your chance to ENROL now for FREE healthcare courses at levels 2, 3, 4 and 5 and gain a pay rise through pay equity. There is huge employer demand for dedicated and qualified healthcare workers - and thanks to the country’s growing, aging population it’s a sector that’s on the rise. Employment opportunities are vast, and offer the chance to make a real difference. Working as a health professional will set you on the path of a truly rewarding career!",
			},
		}
	},
	{
		// https://studyspy.ac.nz/courses/4130/nz-certificate-in-health-and-wellbeing-advanced-support-level-4
		...ignitePromoDetails,
		id: 4130,
		objectID: "4130",
		level: 4,
		name: "NZ Certificate in Health and Wellbeing Level 4",
		description: "2022 is your chance to ENROL now for FREE healthcare courses at levels 2, 3, 4 and 5 and gain a pay rise through pay equity. There is huge employer demand for dedicated and qualified healthcare workers - and thanks to the country’s growing, aging population it’s a sector that’s on the rise. Employment opportunities are vast, and offer the chance to make a real difference. Working as a health professional will set you on the path of a truly rewarding career!",
		url: "https://studyspy.ac.nz/courses/129/nz-certificate-in-health-and-wellbeing-level-3-with-a-strand-in-health-assistance",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604651;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604651&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=623ee00819c7d1a1bdad5ff337d7a418112f594e&location=",

		_snippetResult: {
			description: {
				value: "2022 is your chance to ENROL now for FREE healthcare courses at levels 2, 3, 4 and 5 and gain a pay rise through pay equity. There is huge employer demand for dedicated and qualified healthcare workers - and thanks to the country’s growing, aging population it’s a sector that’s on the rise. Employment opportunities are vast, and offer the chance to make a real difference. Working as a health professional will set you on the path of a truly rewarding career!",
			},
		}
	},

];


const igniteECEPromoHits = [
	{
		// https://studyspy.ac.nz/courses/2701/nz-certificate-in-early-childhood-education-and-care-level-4-online
		...ignitePromoDetails,
		id: 2701,
		objectID: "2701",
		level: 4,
		name: "NZ Certificate in Early Childhood Education and Care Level 4",
		description: "Play a pivotal role in shaping tomorrow’s world, by helping grow the minds of today’s children. If you love kids, and you’re looking for a rewarding, meaningful career, it doesn’t get much better than early childhood education. It’s hands-on, fun and no two days are the same. Better still an early childhood qualification opens doors to a wide range of career options – work as a nanny or in an ECE centre, become a play specialist, or work with children with special needs.",
		url: "https://studyspy.ac.nz/courses/2701/nz-certificate-in-early-childhood-education-and-care-level-4-online",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604652;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604652&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=e7736579a1aed5e9b257dfd99794d3cebd04583d&location=",
		_snippetResult: {
			description: {
				value: "Play a pivotal role in shaping tomorrow’s world, by helping grow the minds of today’s children. If you love kids, and you’re looking for a rewarding, meaningful career, it doesn’t get much better than early childhood education. It’s hands-on, fun and no two days are the same. Better still an early childhood qualification opens doors to a wide range of career options – work as a nanny or in an ECE centre, become a play specialist, or work with children with special needs.",
			},
		}
	},

];

const igniteCookeryPromoHits = [
	{
		// https://studyspy.ac.nz/courses/2032/certificate-in-culinary-arts-level-4
		...ignitePromoDetails,
		id: 2032,
		objectID: "2032",
		level: 4,
		name: "Certificate in Culinary Arts Level 4",
		description: "Love food? Whip up a new career at Ignite Colleges’ cookery school. Gain hands-on training in our state-of-the-art commercial kitchens and learn innovative culinary skills from top chefs. Plus, you’ll graduate with real work experience thanks to our unique internship programme.",
		url: "https://studyspy.ac.nz/courses/2032/certificate-in-culinary-arts-level-4",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604654;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604654&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=6075a572c6fdad95dfb7068652447b7b341dd7f4&location=",
		_snippetResult: {
			description: {
				value: "Love food? Whip up a new career at Ignite Colleges’ cookery school. Gain hands-on training in our state-of-the-art commercial kitchens and learn innovative culinary skills from top chefs. Plus, you’ll graduate with real work experience thanks to our unique internship programme.",
			},
		}
	},

];

const igniteHospitalityPromoHits = [
	{
		// https://studyspy.ac.nz/courses/9323/nz-certificate-in-hospitality-level-4
		...ignitePromoDetails,
		id: 9323,
		objectID: "9323",
		level: 4,
		name: "NZ Certificate in Hospitality Level 4",
		description: "Bars, restaurants, cafes, hotels – the hospitality industry is fun, fast-paced and full of career options. Get in on the action with Level 3 or 4 Hospitality course. It’s practical, fun, and you’ll learn real hospitality skills in our onsite café, bar and barista training areas. You’ll gain experience doing functions and events and earn a great qualification. We’ll even help you find a job!",
		url: "https://studyspy.ac.nz/courses/9323/nz-certificate-in-hospitality-level-4",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604655;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604655&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=d0cc2f5c30089b9f7182d9b68441801f14bcff3e&location=",
		_snippetResult: {
			description: {
				value: "Bars, restaurants, cafes, hotels – the hospitality industry is fun, fast-paced and full of career options. Get in on the action with Level 3 or 4 Hospitality course. It’s practical, fun, and you’ll learn real hospitality skills in our onsite café, bar and barista training areas. You’ll gain experience doing functions and events and earn a great qualification. We’ll even help you find a job!",
			},
		}
	},

];

const igniteFreightPromoHits = [
	{
		// https://studyspy.ac.nz/courses/3954/certificate-in-international-logistics-and-transport-level-3
		...ignitePromoDetails,
		id: 3954,
		objectID: "3954",
		level: 3,
		name: "Certificate in International Logistics and Transport Level 3",
		description: "Are you highly organised with an eye for detail? Does the idea of getting the right product to the right place at the right time excite you? A career in international freight logistics could be just up your alley. Whether you want to work in an office or a warehouse, this qualification will get you started. Learn about hands-on operations, visit the airport, port and logistics companies, and get what you need to succeed in this high demand industry.",
		url: "https://studyspy.ac.nz/courses/3954/certificate-in-international-logistics-and-transport-level-3",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1717216;BID=520604656;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1717216&setID=344408&channelID=0&CID=627498&banID=520604656&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=3d110fc3886d97c610bb241fcaf17537e95b668d&location=",
		_snippetResult: {
			description: {
				value: "Are you highly organised with an eye for detail? Does the idea of getting the right product to the right place at the right time excite you? A career in international freight logistics could be just up your alley. Whether you want to work in an office or a warehouse, this qualification will get you started. Learn about hands-on operations, visit the airport, port and logistics companies, and get what you need to succeed in this high demand industry.",
			},
		}
	},

];

const lenzPilotPromoDetails = {
	providerId: 52,
	providedBy: "Ardmore Flying School",
	providerName: "Ardmore Flying School",
	providerType: "Private Training Establishment",
	providerUrl: "https://studyspy.ac.nz/courses/1907/new-zealand-diploma-in-aviation-aeroplane-and-helicopter",
	providerLogo: "https://ucarecdn.com/93eb0817-bc65-4b28-afab-fefcff733a0a/",
	isPromoted: true,
}

const lenzPilotPromoHits = [
	{
		// https://studyspy.ac.nz/providers/52/ardmore-flying-school-ltd
		...lenzPilotPromoDetails,
		id: 99999999,
		objectID: "99999999",
		name: "New Zealand Diploma in Aviation (Aeroplane and Helicopter)",
		description: "Become a pilot in New Zealand with Ardmore Flying School! Our aerodrome is located just outside of Auckland, NZ's biggest city. If you want your aviation career to take flight, enquire here on StudySpy about our programmes to become a commercial pilot and our team will be in touch with you shortly with all that we have to offer.",
		url: "https://studyspy.ac.nz/courses/1907/new-zealand-diploma-in-aviation-aeroplane-and-helicopter",
		viewTrackingPixel: "https://servedbyadbutler.com/adserve/;ID=175120;size=1x1;type=tpixel;setID=344408;plid=1767580;BID=520650480;wt=0;rnd=CACHE_BUSTER_MACRO",
		clickTrackingLink: "https://servedbyadbutler.com/redirect.spark?MID=175120&plid=1767580&setID=344408&channelID=0&CID=649116&banID=520650480&PID=0&textadID=0&tc=1&type=tclick&mt=1&hc=88f4886f58b367d6fd8389f65fccdbfa785002b5&location=",
		_snippetResult: {
			description: {
				value: "Become a pilot in New Zealand with Ardmore Flying School! Our aerodrome is located just outside of Auckland, NZ's biggest city. If you want your aviation career to take flight, enquire here on StudySpy about our programmes to become a commercial pilot and our team will be in touch with you shortly with all that we have to offer.",
			},
		}
	},

];



const ConnectedHits =  connectHits(({ hits, searchState }) => {
	const { query, hierarchicalMenu } = searchState;

	console.log(searchState);

	//Micro-credential, Disruptive Tech, Bitcoin, NFT, artificial intelligence, Data, Augmented Reality, Virtual Reality, IOT, Emerging Tech
	//const techfutureslabdistruptivePromoKeywords = [
	//	"micro-credential",
	//	"disruptive tech",
	//	"bitcoin",
	//	"nft",
	//	"artificial intelligence",
	//	"data",
	//	"augmented reality",
	//	"virtual reality",
	//	"iot",
	//	"emerging tech",
	//	"emerging",
	//	"tech",

	//];

	// Inject promotions if keyword match is found
	//if (techfutureslabdistruptivePromoKeywords.some(v => (query || "").toLowerCase().includes(v))) {
	//	hits = [
	//		...techfutureslabDisruptivePromoHits,
	//		...hits
	//	];
	//}


	//Postgraduate, data management, change management, strategy, transformation, big data, IOT, technology
	//const techfutureslabPostGradPromoKeywords = [
	//	"postgraduate",
	//	"data management",
	//	"change management",
	//	"strategy",
	//	"transformation",
	//	"big data",
	//	"iot",
	//	"technology",
	//];

	//// Inject promotions if keyword match is found
	//if (techfutureslabPostGradPromoKeywords.some(v => (query || "").toLowerCase().includes(v))) {
	//	hits = [
	//		...techfutureslabPostGradPromoHits,
	//		...hits
	//	];
	//}

	//Masters, Robotics, Digital Technologies, Emerging Tech, Leadership, Disruptive Tech, Digital Transformation
	const techfutureslabMTFPromoKeywords = [
		"masters",
		"robotics",
		"digital technologies",
		"emerging tech",
		"leadership",
		"disruptive tech",
		"digital transformation",
		"emerging",
		"tech",
	];

	// Inject promotions if keyword match is found
	//if (techfutureslabMTFPromoKeywords.some(v => (query || "").toLowerCase().includes(v))) {
	//	hits = [
	//		...techfutureslabMTFPromoHits,
	//		...hits
	//	];
	//}
	//hospo, hospitality, LCQ, restaurant, beverage
	//const igniteHospitalityPromoKeywords = [
	//	"hospo",
	//	"hospitality",
	//	"lcq",
	//	"restaurant",
	//	"beverage",
	//];

	//// Inject promotions if keyword match is found
	//if (igniteHospitalityPromoKeywords.some(v => (query || "").toLowerCase().includes(v))) {
	//	hits = [
	//		...igniteHospitalityPromoHits,
	//		...hits
	//	];
	//}

	//Freight, logistics, forklift, warehouse, cargo, distribution, warehouse, warehousing
	//const igniteFreightPromoKeywords = [
	//	"freight",
	//	"logistics",
	//	"forklift",
	//	"warehouse",
	//	"cargo",
	//	"distribution",
	//	"warehouse",
	//	"warehousing",
	//];

	//// Inject promotions if keyword match is found
	//if (igniteFreightPromoKeywords.some(v => (query || "").toLowerCase().includes(v))) {
	//	hits = [
	//		...igniteFreightPromoHits,
	//		...hits
	//	];
	//}

	//pilot, pilots, flight, flight training, aviation, ppl, cpl, fly, flying, caa, helicopter
	const lenzPilotAds = [
		"pilot",
		"pilots",
		"flight",
		"flight training",
		"aviation",
		"ppl",
		"cpl",
		"fly",
		"flying",
		"caa",
		"helicopter"

	];
	var myHeaders = new Headers(); // Currently empty
	var country_code = "";
	var country_code_hdr = myHeaders.get('CF-IPCountry');
	if (country_code_hdr != null) {
		country_code = country_code_hdr;
	}

	// AD CAMPAIGN PROMOTIONS
	if (!!adCampaignsPromotions) {
		adCampaignsPromotions.forEach(promotion => {
			let matchTick = 0;
			let queryWords = (query || "").toLowerCase().split(" ");
			let existsKeywords = promotion.keywords.some(keyword => {
				let keywordWords = keyword.toLowerCase().split(" ");
				return keywordWords.every(word => queryWords.includes(word));
			});
			let existsInNegative = promotion.negativeKeywords.some(negativeKeyword => {
				let negativeKeywordWords = negativeKeyword.toLowerCase().split(" ");
				return negativeKeywordWords.every(word => queryWords.includes(word));
			});

			if (existsKeywords && !existsInNegative) {
				matchTick++;
				hits = [
					...promotion.promotionData,
					...hits
				];
			}
			hitCountPromotion = 12 - matchTick;
		});
	}
	// END AD CAMPAIGN PROMOTIONS

	// Inject promotions if keyword match is found
	// if (lenzPilotAds.some(v => (query || "").toLowerCase().includes(v)) && country_code.toLowerCase() != "nz") {
	// 	hits = [
	// 	...lenzPilotPromoHits,
	// 		...hits
	// 	];
	// }

	//const vuwPromoKeywords = [
	//	"science",
	//	"sciences",
	//	"physics",
	//	"chemistry",
	//	"engineering",
	//	"chem",
	//	"biology",
	//	"bio",
	//	"engineering",
	//	"engine",
	//	"manufacturing",
	//	"construction",
	//];

	//const vuwPromoSubjects = [
	//	"science",
	//	"engineering",
	//];

	//let subject;

	//if (hierarchicalMenu && hierarchicalMenu["hierarchicalCategories.lvl0"]) {
	//	subject = hierarchicalMenu["hierarchicalCategories.lvl0"].toLowerCase();
	//}

	//var isSubjectMatch = !!(subject && vuwPromoSubjects.some(v => subject.includes(v)));


	//if (vuwPromoKeywords.some(v => (query || "").toLowerCase().includes(v)) || isSubjectMatch) {
	//	hits = [
	//		//...vuwPromoHits,
	//		...hits
	//	];
	//}

	return (
		<div className="ais-Hits">
			<ul className="ais-Hits-list">
				{hits.map(hit =>
					<li
						className={`ais-Hits-item ${hit.isPromoted ? "ais-Hits-item--promoted" : ""}`}
						key={hit.objectID + (hit.isPromoted ? "-ad" : "")}
					>
						{/* {JSON.stringify(hit)} */}
						<Result hit={hit} />
					</li>
				)}
			</ul>
		</div>
	);
});

const Results = connectStateResults((props) => {
	const {
		showSaved,
		hasSaved,
		savedCount,
		searchState,
		searchResults,
		searching,
		allSearchResults
	} = props;

	const hasResults = searchResults && searchResults.nbHits !== 0;
	const promoted: string[] = [];

	// So we can highlight the promoted courses (data isn't attached to the result)
	if (allSearchResults && allSearchResults.userData) {
		allSearchResults.userData.map(datum => {
			if (datum.promoted) {
				promoted.push(datum.promoted);
			}
		});
	}

	const FilterHelper = connectCurrentRefinements((props) => props.items.length ? <div>
		<p className="mh3 mt0 lh-copy black-60">
			Try clearing your filters, to widen your search.
		</p>
		<ClearRefinements />
	</div>: null);

	if (hasResults) {
		// Force a recalculation of the web widget location
		if ((window as any).handleScroll) (window as any).handleScroll();

		return (
			<div className="mw9-l center ph2-l pb4">
				<div className="dt w-100">
					<div className="dtc w-50">
						<Stats translations={{
							stats: (n, _ms) => {
								let result = `${n > 0 ? n.toLocaleString('en-NZ') : "No"} result${n == 1 ? "" : "s"}`

								if (searchState && searchState.query && searchState.query.length > 0) {
									result += ` for "${searchState.query}"`;
								}

								return result;
							}
						}} />
					</div>
					<div className="dtc w-50 tr">
						{(!showSaved && hasSaved) &&
							<Link
								className="link pointer f6 f5-ns dib mr2 mt2 dim tc ph3 pv2 br2 brand-font black-90 bg-black-10"
								to="/search/courses/saved"
							>
								Saved courses ({savedCount})
							</Link>
						}
					</div>
				</div>

				<ConnectedHits
					searchState={searchState}
					promoted={promoted}
				/>

				<Pagination
					showLast={true}
					showFirst={true}
					padding={2}
					translations={{
						previous: "Previous",
						next: "Next",
					}}
				/>
			</div>
		);
	}
	else if (!searching) {
		return (
			<div className="tc pv4 pv5-l">
				<div className="f2">🤔</div>
				<div className="brand-font f3 lh-titl mt2">No results</div>
				<p className="measure-wide center db lh-copy black-60 mt2 tc ph3 mb0">
					We couldn't find anything{searchState.query && " for \"" + searchState.query + "\""}.
				</p>

				<FilterHelper />
			</div>
		);
	}
	else {
		return (
			<div className="tc pv4 pv5-l">
				<div className="brand-font f3 lh-titl mt2">Searching...</div>
			</div>
		);
	}
});

const createUrl = state => {
	if (!state) {
		return null;
	}

	return `?${qs.stringify(state, {
		skipNulls: true,
		strictNullHandling: true,
		filter: (prefix, value) => {
			if (prefix === "configure") {
				return;
			}

			return value;
		}
	})}`;
};

const searchStateToUrl = (props, searchState) => {
	// TODO: encode tag and location correctly

	if (searchState) {
		return `${props.location.pathname}${createUrl(searchState)}`;
	}

	return null;
};

const urlToSearchState = props => {
	let searchState = qs.parse(location.search.slice(1));

	if (props.match.params.tag) {
		// turn the tag query into an algolia-friendly query parameter
		// OR virtualmenu
	}

	if (!props.location || !props.location.search || !props.location.search.slice(1)) {
		return {};
	}

	return searchState;
}

const VirtualMenu = connectMenu(() => null);

interface SearchProps {
	location;
	history;
	match;
}

interface SearchState {
	searchState;
	showHero?: boolean;
}

export default class CourseSearch extends React.Component<SearchProps, SearchState> {
	private debouncedSetState;
	private searchClient;

	constructor(props) {
		super(props);

		const searchState = urlToSearchState(props);

		let urlParams = new URLSearchParams(window.location.search);
		let hasQuery = urlParams.has('query');
		let isMobile = window.matchMedia("(max-width: 480px)").matches;

		this.state = {
			searchState,
			showHero: (!(isMobile || hasQuery)),
		};

		this.searchClient = algoliasearch(appId, apiKey);

		rawStore.forceUpdate = this.forceUpdate.bind(this);
	}

	componentWillReceiveProps(props) {
		if (props.location !== this.props.location) {
			this.setState({ searchState: urlToSearchState(props) });
		}
	}

	onSearchStateChange = searchState => {
		clearTimeout(this.debouncedSetState);

		this.debouncedSetState = setTimeout(() => {
			this.props.history.push(
				searchStateToUrl(this.props, searchState),
				searchState
			);
		}, 700);

		window.scrollTo(0, 0);
		this.setState({ searchState });
	}

	handleSubmit = query => {
		if (query) {
			// Permanently hidden if user submits a query.
			this.setState({ showHero: false }, () => {
				// Restore the query
				//console.log(this.searchClient);
			});
		}
	}

	render() {
		const showSaved = (this.props.match.params.tag && this.props.match.params.tag === "saved");
		const hasSaved = rawStore.savedCourses.size > 0;
		const searchQuery = this.state.searchState.query ? `?query=${this.state.searchState.query}` : null;
		const heroImage = "https://ucarecdn.com/2df04666-5a94-44fb-bcbb-68dd714ec30b/";

		return (
			<store.Provider value={rawStore}>
				<InstantSearch
					searchClient={this.searchClient}
					indexName={indexName}
					searchState={this.state.searchState}
					onSearchStateChange={this.onSearchStateChange}
					createURL={createUrl}
				>
					<Configure
						hitsPerPage={hitCountPromotion}
						clickAnalytics
						analyticsTags={["studyspy"]}
					/>

					{(this.state.showHero && !showSaved) ? (
						<div className="bg-white">
							<div className="center pa3 pv5-ns mw9-l">
								<div className="flex flex-column-reverse dt-ns w-100">
									<div className="dtc v-mid w-66-ns">
										<h1 className="brand-font tc tl-ns fw7 lh-title f3 f1-ns mb0 brand-accent mt0">
											Compare every&nbsp;course.
										</h1>
										<p className="lh-copy tc tl-ns black-90 measure mt2 f5 f4-ns brand-font">
											Search every course in New Zealand &ndash; from apprenticeships
											to&nbsp;university degrees, from Kaitaia to&nbsp;Invercargill.
										</p>

										<div className="tailwind">
												<div className="w-full">
												<SearchBoxDebounced
													delay={200}
													autoFocus
													showLoadingIndicator
													showButton
													placeholder="Search courses..."
													translations={{placeholder: "Search courses..."}}
													onSubmit={this.handleSubmit}
													onChange={() => window.scrollTo(0, 0)}
												/>
											</div>
										</div>
									</div>
									<div className="db dtc-ns v-mid w-60 w-40-ns center tc">
										<picture>

											<img src={heroImage}
													 alt=""
													 className="dib " //hiding for now className="dib"
													 style={{maxWidth: "100%", maxHeight: "300px"}}
													 srcSet={`${heroImage}-/resize/x320/-/format/jpg/-/quality/lighter/ 320w,
														${heroImage}-/resize/x450/-/format/jpg/-/quality/lighter/ 450w,
														${heroImage}-/resize/x640/-/format/jpg/-/quality/lighter/ 640w,
														${heroImage}-/resize/x750/-/format/jpg/-/quality/lighter/ 750w,
														${heroImage}-/resize/x800/-/format/jpg/-/quality/lighter/ 800w,
														${heroImage}-/resize/x900/-/format/jpg/-/quality/lighter/ 900w,
														${heroImage}-/resize/x1000/-/format/jpg/-/quality/lighter/ 1000w,
														${heroImage}-/resize/x1200/-/format/jpg/-/quality/lighter/ 1200w`}
												sizes="(min-width: 1000px) 50vw, 100vw" />
										</picture>
									</div>
								</div>
							</div>
						</div>
					) : (
						<div className="tailwind">
							{ReactDOM.createPortal(
								<SearchBoxDebounced
									delay={200}
									autoFocus
									showLoadingIndicator
									placeholder="Search courses..."
									onSubmit={this.handleSubmit}
									translations={{ placeholder: "Search courses..." }}
									onChange={() => window.scrollTo(0, 0)}
								/>,
								document.getElementById("search-box-portal")
							)}
						</div>
					)}

					<div className="search__header">
						<ConnectedFilters />
					</div>

					{showSaved &&
						<React.Fragment>
							{Array.from(rawStore.savedCourses).map(x =>
								<VirtualMenu attribute="objectID" defaultRefinement={x.toString()} key={x} />)
							}

							<div className="pv4">
								<div className="mw9-l center ph3">
									<h1 className="mt0 brand-font">
										Saved courses
									</h1>

									<p className="lh-copy measure-wide">
										Share these courses with your parents, teacher, or careers advisor,
										and they'll help you decide on the perfect course.
									</p>

									{hasSaved ? (
										<div>
											<Link to="/search/courses"  className="link pointer dib mr2 dim tc ph3 pv2 br2 brand-font bg-brand-accent white">
												Back to course search
											</Link>
											<div onClick={window.print} className="pointer dib mr2 dim tc ph3 pv2 br2 brand-font bg-black-10">
												Print
											</div>
										</div>
									) : (
										<React.Fragment>
											<p className="lh-copy measure-wide fw6">
												You haven't saved any courses yet.
											</p>

											<Link to="/search/courses" className="link dim pa3 brand-font bg-brand-accent white tc br2 dib mt2">
												Search for courses
											</Link>
										</React.Fragment>
									)}
								</div>
							</div>
						</React.Fragment>
					}

					{<Menu attribute="Tags" />}

					{((showSaved && hasSaved) || !showSaved) &&
						<Results
							showSaved={showSaved}
							hasSaved={hasSaved}
							savedCount={rawStore.savedCourses.size}
						/>
					}
				</InstantSearch>
			</store.Provider>
		);
	}
}
